<bl-page-card-container
  data-smartpresentation="container-pagina"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
>
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY" class="mr-2"></ag-views-toolbar>

      <bl-rps-prestadores-registrados-filtro
        [data]="filterData"
        (dataChange)="onFiltroChange($event)"
      ></bl-rps-prestadores-registrados-filtro>

      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="ml-2 p-button p-button-md flex-shrink-0 white-space-nowrap"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        (click)="reloadData()"
      ></button>

      <bl-pesquisar-input
        class="ml-5 mr-5"
        (onSearch)="onSearch($event)"
        [disabled]="!rowData?.length"
      ></bl-pesquisar-input>

      <button
        class="p-button p-button-outlined p-button-icon-only mr-2"
        (click)="exportExcel()"
        [disabled]="!rowData?.length"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
      >
        <i class="pi pi-file-excel"></i>
      </button>

      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
      >
        <i class="pi" [ngClass]="(fullscreen$ | async) ? 'pi-window-minimize' : 'pi-window-maximize'"></i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-column flex-1 min-h-0">
    <div class="grid-wrapper">
      <ag-grid-angular
        #agGrid
        data-smartpresentation="ag-grid"
        class="ag-theme-balham w-full"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        [style.height]="gridHeight$ | async"
        [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
      >
      </ag-grid-angular>
    </div>

    <div class="pagination-container flex justify-content-center mt-3">
      <bl-pagination
        [data]="rowData"
        [total]="rowTotal"
        [(page)]="page"
        [(size)]="pageSize"
        [(reset)]="paginationReset"
        (onChange)="onPageChange($event)"
      >
      </bl-pagination>
    </div>
  </div>
</bl-page-card-container>
